// The Bulk-View rows of the DFL taxonomy. Kept separate from the driver-app
// unreachable reasons, which exclude these rows. Values are UPPER_SNAKE to
// match the reason codes the driver app writes, so reports can group both.

export const DISPATCH_REASON = {
  value: 'DISPATCH',
  label: 'Dispatch',
  description:
    'Marked as DISPATCH for an event that affected many stops at the same time.',
};

export const DISPATCH_SUB_REASON_OTHER = 'OTHER';

export const DISPATCH_NOTE_MIN_LENGTH = 10;

export const DISPATCH_SUB_REASONS = [
  {
    value: 'LINEHAUL_DELAY',
    label: 'Linehaul Delay',
    description:
      'The linehaul truck arrived late or never arrived, so the stops on it had no food in market on time.',
  },
  {
    value: 'LINEHAUL_QUALITY',
    label: 'Linehaul Quality',
    description:
      'The linehaul load arrived out of temperature, short, mispicked, or on an unclean trailer, so the food could not be delivered.',
  },
  {
    value: 'VAN_ISSUES',
    label: 'Van Issues',
    description:
      'A van was out of service for the day, mechanical or refrigeration, and its stops were not covered.',
  },
  {
    value: 'EXTREME_WEATHER',
    label: 'Extreme weather',
    description:
      'Weather closed a lane, a market, or a set of sites for the day.',
  },
  {
    value: 'DRIVER_CALL_OFF',
    label: 'Driver call-off',
    description: 'A driver called off and the route was not covered.',
  },
  {
    value: 'COOLER_GOING_DOWN',
    label: 'Cooler going down',
    description:
      'The market cooler lost temperature or power, so food staged in it could not go out.',
  },
  {
    value: 'TOTE_NOT_FOUND',
    label: 'Tote Not Found',
    description:
      'Totes for a group of stops were never packed, never loaded, or lost in the hub.',
  },
  {
    value: DISPATCH_SUB_REASON_OTHER,
    label: 'Other',
    description:
      'An event that hit many stops at once and none of the above reasons fit. Always add a note.',
  },
];

export function requiresDispatchNote(subReason) {
  return subReason === DISPATCH_SUB_REASON_OTHER;
}

export function dispatchNoteLength(note) {
  return (note || '').trim().length;
}

export function isDispatchReasonComplete({ subReason, note } = {}) {
  if (!DISPATCH_SUB_REASONS.some((r) => r.value === subReason)) return false;
  if (requiresDispatchNote(subReason)) {
    return dispatchNoteLength(note) >= DISPATCH_NOTE_MIN_LENGTH;
  }
  return true;
}

export function dispatchSubReasonLabel(value) {
  const match = DISPATCH_SUB_REASONS.find((r) => r.value === value);
  return match ? match.label : value || '—';
}

export function dispatchSubReasonDescription(value) {
  const match = DISPATCH_SUB_REASONS.find((r) => r.value === value);
  return match ? match.description : '';
}
